import { render, staticRenderFns } from "./RemindGuests.vue?vue&type=template&id=4b413ff7"
import script from "./RemindGuests.vue?vue&type=script&lang=js"
export * from "./RemindGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports